import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  Spinner,
} from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useAPI } from "hooks/useAPI"
import moment from "moment"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const Embossing = props => {
  const REPORT_ID = 10

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  const [anoEscolhido, setAnoEscolhido] = useState(0)

  let anos = []

  const traduzido = payload?.data?.columns[0]
    .filter((e, i) => i > 0)
    .map((el, idx) => {
      !anos.includes(moment(el, "YYYY-MM-DD").year())
        ? anos.push(moment(el, "YYYY-MM-DD").year())
        : null
      return {
        ano: moment(el, "YYYY-MM-DD").year(),
        coluna: moment(el, "YYYY-MM-DD").format("DD/MM"),
        valor: payload?.data?.columns[1][idx + 1],
      }
    })

  const valores = traduzido
    ?.filter(e => e.ano === anos[anoEscolhido])
    .map(el => {
      return el.valor
    })
  const colunas = traduzido
    ?.filter(e => e.ano === anos[anoEscolhido])
    .map(el => {
      return el.coluna
    })

  const columns = payload?.data?.columns[0]
    .filter((e, i) => i > 0)
    .map((item, idx) => {
      return moment(item, "YYYY-MM-DD").format("DD/MM")
    })

  const series = [
    {
      name: payload?.data?.columns[1][0],
      data: valores,
    },
  ]

  const chartOptions = {
    chart: {
      height: 400,
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      // color: "#FF0000",
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      width: [1, 1],
      curve: "straight",
    },
    grid: {
      row: {
        colors: ["transparent", "transparent"],
        opacity: 0.2,
      },
      borderColor: "#f1f1f1",
    },
    markers: {
      style: "inverted",
      size: 3,
    },
    xaxis: {
      categories: colunas,
    },
  }
  return (
    <Card>
      <CardHeader tag={"h4"} className="bg-transparent border-bottom">
        {!isLoading && (
          <Row>
            <Col className="mt-2 pb-1">{payload?.title}</Col>
            <Col sm={2}>
              {Object.keys(anos).length > 0 && (
                <Col>
                  <Input
                    className="form-control-sm float-end"
                    type="select"
                    style={{ width: "150px" }}
                    onChange={e => {
                      setAnoEscolhido(e.target.value)
                    }}
                  >
                    {anos.map((item, idx) => {
                      return (
                        <option key={idx} value={idx}>
                          {item}
                        </option>
                      )
                    })}
                  </Input>
                </Col>
              )}
            </Col>
          </Row>
        )}
        {isLoading && (
          <Row>
            <Col>
              <span className="placeholder col-3"></span>
            </Col>
            <Col>
              <Col>
                <Spinner className="ms-2 float-end" color="secondary" />
              </Col>
            </Col>
          </Row>
        )}
      </CardHeader>
      <CardBody>
        {isLoading && (
          <div className="mt-3" style={{ textAlign: "center" }}>
            <Spinner
              className="ms-2"
              style={{ width: "4rem", height: "4rem" }}
              color="primary"
            />
          </div>
        )}
        {!isLoading && (
          <ReactApexChart
            options={chartOptions}
            series={series}
            type="line"
            height={400}
            className="apex-charts"
          ></ReactApexChart>
        )}
      </CardBody>
    </Card>
  )
}

export default Embossing
